module.exports = __webpack_public_path__ + "img/bitcoincom.33a6be94.png";